import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHead: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHead"><Path d="M10.9621 2C6.5665 2 3 5.55512 3 9.94444C3 11.7926 3.63342 13.4951 4.69469 14.8447C6.03524 16.5495 6.02228 18.1729 6.00434 20.4197C6.00221 20.6872 6 20.9636 6 21.25V22H15V18.9167H19V13.9984L21.8399 12.5311L21.3736 11.8333C21.2452 11.6411 21.1192 11.4537 20.9956 11.27C19.9506 9.71578 19.0803 8.42155 18.4145 6.72377C17.1621 3.53044 14.1314 2 10.9621 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHead;
